Vue.component('ack-newsletter', {
    delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
    template: '#ack-newsletter',
    mixins: [languageMixins],
    created() {
      
    },
    mounted() {
      appLog.log('ack-newsletter mounted')
      this.setPageIsLoading(false)
    },
    props:{
      // dataIn: {
      //   type: Object,
      //   required: true
      // }
      
    },
    computed: {
      //...Vuex.mapGetters('sliders', ['slidersLists']), 
      //...Vuex.mapGetters('articles', ['articlesArray']),
      isMobile(){
        return this.$parent.isMobile
      },
    },
    data() {
      return {
        pageId: 'newsletter-page',
      }
    },
    methods: {
      ...Vuex.mapActions(['setPageIsLoading'])
      //...Vuex.mapActions('sliders', ['getSlideList'])
      
      
      
  
    },
    beforeDestroy() {
      
    },
    watch: {
      
      data1: {
        handler() {
          
          
          
        },
        deep: false
      }
    }
  })